/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

import { getTheme, ISpinnerStyles, IStackStyles, IStackTokens } from "@fluentui/react";

const theme = getTheme();

export const Error = styled.div`
  color: red;
  margin-top: 5px;
`;

/**
 * The stack containing all of the form elements.
 */
export const containerStyles: IStackStyles = {
  root: {
    padding: "1.5rem",
    borderRadius: "8px",
    height: "90vh",
  },
};

/**
 * The horizontal gap stack tokens
 */
export const horizontalGapStackTokens: IStackTokens = {
  childrenGap: 10,
  padding: 10,
};

/**
 * The vertical gap stack tokens
 */
export const verticalGapStackTokens: IStackTokens = {
  childrenGap: 36,
  padding: 10,
};

/**
 * Styles for the loading spinner
 */
export const spinnerStyles: ISpinnerStyles = {
  root: {
    marginTop: 32,
  },
};
